<!-- <div class="header"></div> -->
<div class="site-container">
    <app-ui-layout-header></app-ui-layout-header>
    <div class="appeal-form-result">
        <div class="appeal-form-result-head">Başvurunuz Alınmıştır</div>
        <div class="appeal-form-result-explain">
            Başvurunuzla ilgili ek dosya göndermek isterseniz; <br>
            İlgili dosyalarını içeren bir flash disk’i aşağıda yer alan isim ve adrese gönderebilirsiniz.
            <br><br>
            <b>
                <span class="name">Beyza İlçin</span><br>
                <span>Milliyet Sanat Dergisi</span><br>
                Demirören Medya Center 100. Yıl Mah. <br>2264 Sokak No:1
                34218 <br>Bağcılar/İstanbul<br><br>
                Ayrıntılı bilgi için;<br>
                <a href="tel:+0-212-337-98-29">0212 337 98 29 </a><br><a
                    href="mailto:heykeldeyenikesifler@milliyet.com.tr"> heykeldeyenikesifler@milliyet.com.tr</a>
            </b>
        </div>
        <div class="new-title-add">
            <a href="/basvuru-form">
                <span>Yeni Başvuru</span>
            </a>
        </div>
    </div>
</div>
<!-- <div class="footer">
</div> -->